import { DiscountElementTargetType } from '@erp/shared-types';

/**
 * Display names for element target types, aligned with the Product Catalog's
 * classification naming: PRODVIEW segments 1..3 are Family / Group / Model
 * there, so the same words are used here (the old "Category / Product line /
 * Family" wording described the same segments and confused cross-page use).
 */
export const TARGET_TYPE_LABELS: Record<DiscountElementTargetType, string> = {
  [DiscountElementTargetType.PRODUCT_VARIANT_ID]: 'Product ID',
  [DiscountElementTargetType.PRODUCT_CATEGORY]: 'Family',
  [DiscountElementTargetType.PRODUCT_LINE]: 'Group',
  [DiscountElementTargetType.PRODUCT_FAMILY]: 'Model',
  [DiscountElementTargetType.PRODUCT_GROUP]: 'Model group',
  [DiscountElementTargetType.ALL_PRODUCTS]: 'All products',
};

/** Lowercase variant for sublabels under target values. */
export function targetTypeSublabel(type: DiscountElementTargetType): string {
  return TARGET_TYPE_LABELS[type].toLowerCase();
}
